import React, { Fragment, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { isEmpty } from 'lodash-es';
import {
  BaseBox,
  Heading2,
  Heading4,
  InputPrefix,
  DoconInput,
  DoconInputWrapper,
  Icons,
} from '@docon/docon-ui-library';
import Layout from 'components/Layout';
import Card from './Card';
import { getAggregateDoctors } from 'redux/reducer/doctor';
import { Loader, Image } from 'shared';
import { colors } from 'utilities/colorConfig';
import { cleverTapAnl } from 'utilities';
import { EventDoctorSelect } from 'utilities/clevertapEvent';

export type IProps = RouteComponentProps;

const Root = styled(Layout)`

  ${InputPrefix} { width: 45px; }

  .rootClassName {
    position: sticky;
    top: -10px;

    ${DoconInputWrapper} {
      margin-bottom: 1rem;
      background-color: ${colors.white};
      --inp-height: 45px;
    }
  }

  .zeroCase {
    text-align: center;
    margin-top: 70px;
    font-weight: 600;

    img {
      max-width: 100%;
    }

    ${Heading4} {
      font-weight: normal;
      color: ${colors.secondaryColor};
    }
  }
`;

function Doctors({ history }: IProps) {
  const { user } = useSelector(state => state.auth);
  const { doctorsByUserId, isFetchingDoctors } = useSelector(state => state.doctor);
  const dispatch = useDispatch();

  const doctors = doctorsByUserId[user.userID] || [];

  useEffect(() => {
    if (user.userID && isEmpty(doctors))
      dispatch(getAggregateDoctors({
        userID: user.userID,
        mobileNumber: user.mobileNumber,
      }));
  }, [user]);

  function handleCardClick({ shortUrl, rank, doctorID }: any) {
    cleverTapAnl.event({
      event_name: 'doctor_select',
      event: {
        page_name: 'my_doctors',
        is_search_active: false,
        search_term: '',
        doctor_id: doctorID,
        rank,
      },
    } as EventDoctorSelect);
    history.push(`/doctors/${shortUrl}`);
  }

  function handleSearchClick() {
    history.push('/doctors/search');
  }

  function renderContent() {

    if (isEmpty(doctors)) {
      return (
        <BaseBox className='zeroCase'>
          <Image src='/images/empty-states/esx@2x.svg' />
          <Heading2 mt={'30px'} title='No Doctors' />
          <Heading4 title='You have not consulted with any doctors' />
        </BaseBox>
      );
    }

    return (
      doctors.map((doctor: any, index: number) => (
        <Card
          key={doctor.doctorID}
          rank={index + 1}
          pageName='my_doctors'
          doctor={doctor}
          onClick={handleCardClick}
        />
      ))
    );
  }

  return (
    <Root>
      {
        isFetchingDoctors ? <Loader /> : (
          <Fragment>
            <DoconInput
              name='search'
              value=''
              placeholder='Search and book your doctor'
              rootClassName={'rootClassName'}
              prefix={<Icons.SearchIcon /> as any}
              onClick={handleSearchClick}
            />

            {renderContent()}
          </Fragment>
        )
      }
    </Root>
  );
}

export default Doctors;